import { CreditCard } from "lucide-react";

export const TransaccionTopbar = () => {
  return (
    <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center px-4 md:px-[32px] py-4 md:py-[20px] border-b border-gray-200 bg-white sticky top-0 z-10 gap-4 sm:gap-0">
      <div>
        <h1 className="text-[20px] font-bold flex items-center gap-[10px] m-0 text-gray-900">
          {/* <svg width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" className="text-primary">
            <rect x="1" y="4" width="22" height="16" rx="2" />
            <line x1="1" y1="10" x2="23" y2="10" />
          </svg> */}
          <CreditCard size={22} color="#4f6df5" strokeWidth={2} />
          Transacciones
        </h1>
        <p className="mt-0.5 text-xs text-muted-foreground">Historial completo de pagos y movimientos · Marzo 2026</p>
      </div>
      <div className="flex items-center gap-2 w-full sm:w-auto">
        <button className="flex items-center justify-center w-full sm:w-auto px-4 py-2 text-xs font-semibold transition-all bg-transparent border rounded-lg border-border text-muted-foreground hover:border-foreground hover:text-foreground">
          <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" className="mr-1.5">
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
            <polyline points="7 10 12 15 17 10" />
            <line x1="12" y1="15" x2="12" y2="3" />
          </svg>
          Exportar CSV
        </button>
      </div>
    </div>
  );
};

export default TransaccionTopbar;